<template>
<div id="home">
    <van-nav-bar title="主机管理" fixed placeholder right-text="退出" @click-right="onClickRight" />
    <van-search placeholder="请输入搜索内容" v-model="searchVal"  />


  <div class="list_flexd" style="margin-top: 8px;">
    <host-card class="list_flexd_item" v-for="item in list.filter((lf)=>lf.long_name.indexOf(searchVal)>=0)" :obj="item" @openPupop="handle_open_popup"></host-card>
    
  </div>
  
    <host-info ref="hostInfo"></host-info>

</div>
</template>

<script>
// @ is an alias to /src
import {
    getServerLst
} from "./../api"

import hostInfo from "./components/hostInfo.vue"
import hostCard from "./components/hostCard.vue";

export default {
    name: 'HomeView',
    components: {
        hostInfo,
        hostCard
    },
    data() {
        return {
          searchVal:"",
            showpopup: false,

            list: [],

            timer: "",
        };
    },
    created() {
      
    },
    // 注销
    beforeDestroy() {
        clearTimeout(this.timer)
    },
    mounted() {
        this.onLoad()

        this.timer = setTimeout(() => {
            this.onLoad()
        }, 10000);
    },
    methods: {
        onLoad() {
            let header = {
                "x-access-token": localStorage.getItem('token')
            }

            this.$http.get(getServerLst, {
                headers: header
            }).then(res => {
                console.log(res)
                if (res.data.code == 200) {

                    res.data.result.map(item => {
                        item.cpu = ((1 - item.cpu.idle) * 100).toFixed(2);
                        item.memory_available = ((item.memory.available) / (1024 * 1024 * 1024)).toFixed(2);
                        item.memory_total = ((item.memory.total) / (1024 * 1024 * 1024)).toFixed(2);
                        item.memory_used = (((item.memory.total - item.memory.available) / item.memory.total) * 100).toFixed(2);

                        item.long_name=item.alias+'_'+item.serverId;
                    })

                    this.list = res.data.result
                }

            }).catch(err => {
                console.log(err)
            })
        },
        onClickRight() {
            localStorage.removeItem('token')
            this.$router.push('/login')
        },
        handle_open_popup(obj) {
            console.log(obj)

            this.$nextTick(() => {
                this.$refs.hostInfo.handle_show_popup(obj);
            })

        },
        handle_close_popup() {
            this.showpopup = false;
        },
    }
};
</script>

<style lang="less">
#home {
    width: 100vw;
    min-height: 100vh;
    height: 100%;
    background-color: #efefef;
    padding-bottom: 30px;

    .list {
        width: 94vw;
        margin: auto;
        margin-top: 8px;
    }
}

.list_item {
    width: 100%;

    .van-cell {
        .van-cell__title {
            width: 30%;
            flex: none;
            text-align: left;
        }

        .van-cell__value {}
    }
}


.list_flexd{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    // .van-cell{
    //   width: 48%;
    // }
    width: 94vw;
    margin: auto;

  .list_flexd_item{
    width: 45%;
    margin: 1px;
    &:last-child {
  // margin-right: auto;
}
  }
}
</style>
